// 函数重载：支持泛型类型安全（必须传 defaultData）
function safeJSONParse<T>(data: string, defaultData: T, contextInfo?: Record<string, any>): T;
// 函数重载：向后兼容，不传 defaultData 时返回 any
function safeJSONParse(data: string): any;

// 实现函数
function safeJSONParse<T>(data: string, defaultData?: T, contextInfo?: Record<string, any>): T | any {
    if (!isJSONString(data)) {
        return defaultData !== undefined ? defaultData : {};
    }

    let result: T | any = defaultData !== undefined ? defaultData : {};

    try {
        result = JSON.parse(data);
    } catch (error) {
        const Sentry = (window as any).Sentry;
        if (Sentry) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            const wrappedError = new Error(`[JSON_PARSE_ERROR] Failed to parse JSON: ${errorMessage}`);
            // 保留原始错误堆栈，拼接到 wrappedError 中（可选）
            if (error instanceof Error && error.stack) {
                wrappedError.stack += '\nCaused by: ' + error.stack;
            }
            Sentry.captureException(wrappedError, {
                level: 'error',
                mechanism: {
                    type: 'generic',
                    handled: true,
                },
                extra: {
                    errorMessage,
                    inputData: data,
                    context: contextInfo || {},
                    errorType: 'JSON_PARSE_ERROR',
                },
            });
        }
    } finally {
        return result;
    }
}

function isJSONString(data: string) {
    return (
        typeof data === 'string' &&
        ((data.startsWith('{') && data.endsWith('}')) || (data.startsWith('[') && data.endsWith(']')))
    );
}
export { isJSONString, safeJSONParse };
